import heroImg from "@/assets/hero-porsche.webp";
import heroImgMobile from "@/assets/hero-porsche-mobile.webp";

export function HeroImage({ className = "" }: { className?: string }) {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      <picture>
        <source media="(max-width: 639px)" srcSet={heroImgMobile} type="image/webp" />
        <img
          src={heroImg}
          alt="Blank blå Porsche etter bilvask hos Drammen Car Wash i Drammen"
          className="h-full w-full object-cover hero-drift"
          fetchPriority="high"
          decoding="async"
          width={1600}
          height={905}
        />
      </picture>
      <div className="absolute inset-0 gradient-hero" />
    </div>
  );
}
